import type { Rubric, ApiResponse } from './types';
import { apiGet, apiPost, apiPut } from '../services/api';

export async function getRubric(id: string): Promise<Rubric> {
  try {
    const res = await apiGet<ApiResponse<Rubric>>(`/rubrics/${id}`);
    if (!res.success || !res.data) {
      throw new Error(res.error ?? 'Failed to fetch rubric');
    }
    return res.data;
  } catch (err) {
    if (err instanceof TypeError && err.message === 'Failed to fetch') {
      throw new Error('Network error: unable to reach the server');
    }
    throw err;
  }
}

export async function listRubrics(competencyId?: string): Promise<Rubric[]> {
  try {
    const path = competencyId
      ? `/rubrics?competency_id=${encodeURIComponent(competencyId)}`
      : '/rubrics';
    const res = await apiGet<ApiResponse<Rubric[]>>(path);
    if (!res.success || !res.data) {
      throw new Error(res.error ?? 'Failed to fetch rubrics');
    }
    return res.data;
  } catch (err) {
    if (err instanceof TypeError && err.message === 'Failed to fetch') {
      throw new Error('Network error: unable to reach the server');
    }
    throw err;
  }
}

export async function createRubric(data: Partial<Rubric>): Promise<Rubric> {
  try {
    const res = await apiPost<ApiResponse<Rubric>>('/rubrics', data);
    if (!res.success || !res.data) {
      throw new Error(res.error ?? 'Failed to create rubric');
    }
    return res.data;
  } catch (err) {
    if (err instanceof TypeError && err.message === 'Failed to fetch') {
      throw new Error('Network error: unable to reach the server');
    }
    throw err;
  }
}

export async function updateRubric(id: string, data: Partial<Rubric>): Promise<Rubric> {
  try {
    const res = await apiPut<ApiResponse<Rubric>>(`/rubrics/${id}`, data);
    if (!res.success || !res.data) {
      throw new Error(res.error ?? 'Failed to update rubric');
    }
    return res.data;
  } catch (err) {
    if (err instanceof TypeError && err.message === 'Failed to fetch') {
      throw new Error('Network error: unable to reach the server');
    }
    throw err;
  }
}